import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import Loader from '@shared/components/loader';
import { cn } from '@shared/lib/utils';
import { useEffect } from 'react';

interface DownloadLoaderProps {
  downloadStatus?: 'idle' | 'generating' | 'generated';
  labels?: {
    idle?: string;
    generating?: string;
    generated?: string;
  };
}

export default function DownloadLoader({
  downloadStatus,
  labels,
}: DownloadLoaderProps) {
  const idleLabel = labels?.idle ?? 'Preparing...';
  const generatingLabel = labels?.generating ?? 'Generating PDF...';
  const generatedLabel =
    labels?.generated ?? 'PDF generated. You can now close this tab.';
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div
      className={cn(
        'fixed inset-0 flex items-center justify-center bg-primary-900 bg-opacity-50 z-50'
      )}
    >
      <div className="flex items-center space-x-3 rounded bg-gray-00 p-4 py-3">
        {downloadStatus !== 'generated' && <Loader size="sm" color="primary" />}
        <Text className="shrink-0" variant="subtle">
          {downloadStatus === 'idle' && idleLabel}
          {downloadStatus === 'generating' && generatingLabel}
          {downloadStatus === 'generated' && (
            <div className="flex items-center gap-2">
              <Icons.checkCircle className="mx-auto size-6 text-secondary-500" />
              <Text variant="subtle">{generatedLabel}</Text>
            </div>
          )}
        </Text>
      </div>
    </div>
  );
}
